import { AIRPORT, LOCAL_RENTAL, MOB_CABS_LANDING, MOB_CABS_LISTING, MOB_CABS_REVIEW, ONE_WAY, ROUND_TRIP } from "../utils/util-constants"
import { gcBookingReviewScreen, gcHomeScreen, gcTripCategoryScreen } from "../config/omni"

export enum CTA_TYPE {
  BUTTON        = "Button",
  HYPER_LINK    = "Hyperlink",
  RADIO_BUTTON  = "Radio Button",
  IMAGES        = "Images"
}

export const getActionNameForOmniture = (pageName : string, ctaName : string, isClicked : boolean = true) : string => {
  let actionName = ''

  switch (pageName) {

    case gcHomeScreen :
      actionName = `${MOB_CABS_LANDING}_${ctaName}_${isClicked ? 'clicked' : 'selected'}`
      break

    case gcTripCategoryScreen :
      actionName = `${MOB_CABS_LISTING}_${ctaName}_${isClicked ? 'clicked' : 'selected'}`
      break

    case gcBookingReviewScreen :
      actionName = `${MOB_CABS_REVIEW}_${ctaName}_${isClicked ? 'clicked' : 'selected'}`
      break
  }

  return actionName
}

export const getTripTypeForOmniture = (tripType : string) : string => {
  let tripTypeVal : string = ''
  switch (tripType) {

    case ONE_WAY :
      tripTypeVal = 'one-way'
      break

    case ROUND_TRIP : 
      tripTypeVal = 'round-trip'
      break

    case LOCAL_RENTAL :
      tripTypeVal = 'hourly_rental'
      break

    case AIRPORT :
      tripTypeVal = 'airport'
      break
  }

  return tripTypeVal
}

export const getTripTypeForHOB = (tripType : string) : string => {
  let tripTypeVal : string = ''
  switch (tripType) {

    case 'OW' :
      tripTypeVal = 'ONE_WAY'
      break

    case 'RT' : 
      tripTypeVal = 'Round_TRIP'
      break

    case 'HR' :
      tripTypeVal = 'LOCAL_RENTAL'
      break

    case 'AT' :
      tripTypeVal = 'AIRPORT'
      break
  }

  return tripTypeVal
}

export function pushOmniEvents(data : {eventName : string, details : any}) {
  try {
    window.adobeDataLayer = window.adobeDataLayer || []
    window.adobeDataLayer.push({
      event: data.eventName,
      ...data.details
    })
  } catch (err) {
    console.log('Error pushing omni events')
  }
}